import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class CurrencyDisplayService {

  private currencyCodeLocaleConfig = {
    'INR': { locale: 'en-IN' },
    'USD': { locale: 'en-US' },
    'EUR': { locale: 'en-DE' },
    'HKD': { locale: 'en-HK' },
    'AUD': { locale: 'en-AU', customSymbol: 'A', replaceDefault: false },
    'CAD': { locale: 'en-CA', customSymbol: 'C', replaceDefault: false },
    'MXN': { locale: 'en-MX', customSymbol: 'Mex$', replaceDefault: true },
    'CNY': { locale: 'ii-CN', customSymbol: 'CNY¥', replaceDefault: true },
    'JPY': { locale: 'ja-JP', customSymbol: 'JPY¥', replaceDefault: true },
    'PLN': { locale: 'pl-PL' },
    'TRY': { locale: 'tr-TR' },
    'MYR': { locale: 'ms-MY' },
  }

  constructor(
    private dataService: DataService
  ) { }

  getFormattedCurrencyStr(amtDetail) {
    return this.dataService.formatNumberAsCurrencyWithLocale(amtDetail.amt, this.currencyCodeLocaleConfig[amtDetail.curr] || 'en-US', amtDetail.curr || 'INR');
  }

  getFormattedCurrencyStrForAmountAndCurrency(amt, currencyCode) {
    return this.dataService.formatNumberAsCurrencyWithLocale(amt, this.currencyCodeLocaleConfig[currencyCode] || 'en-US', currencyCode || 'USD');
  }

}
